import { Navigate, useSearchParams } from 'react-router-dom'
import { useFeatureFlag, useFeatureFlagsStatus } from 'services/feature-flags'
import { ProtectionPage } from './protection-page'

/** The old page's tabs, mapped to the page each one became. Anything else — no param,
 *  `tab=protection`, a stale value — is the settings half. */
const CUSTOM_RULES_TABS = ['rules', 'analysis']

/**
 * DEV-2422 W13 — the cutover for `/asset/:assetId/protection`.
 *
 * The old AI + Custom Rules page is split into AI Protection and Custom Rules. Once the
 * flag is on, this route is a bookmark and it goes to the half that carries the settings
 * it used to open on; with the flag off it still renders the old page, because that
 * workspace has nowhere else to go.
 *
 * Delete this file, `protection-page.tsx` and `components/protection-panel/` when the
 * flag is retired. `components/rules-panel/` must STAY either way — the Custom Rules
 * page imports `mapFetchedRules` from it.
 */
export const ProtectionRedirect = () => {
	const customRulesV2Enabled = useFeatureFlag('custom_rules_v2')
	const { flagsReady } = useFeatureFlagsStatus()
	const [searchParams] = useSearchParams()

	// A blank frame rather than a flash of the old page then a bounce: `useFeatureFlag`
	// answers false while PostHog is still resolving.
	if (!flagsReady) return null
	if (customRulesV2Enabled) {
		// A bookmark on `?tab=analysis` wants the rules, not the detection settings, and
		// sending it to AI Protection lands it on the one half that cannot show them.
		//
		// The rest of the query string is dropped ON PURPOSE rather than forwarded:
		// neither new page reads one, and a `from`/`to` carried over would be a date
		// filter the user was shown and never got — the same reason §2 took date scoping
		// off the dashboard's drill-through.
		const tab = searchParams.get('tab')
		const destination =
			tab && CUSTOM_RULES_TABS.includes(tab)
				? '../custom-rules'
				: '../ai-protection'
		return <Navigate to={destination} replace />
	}
	return <ProtectionPage />
}
